import React from 'react'
import { Badge, Box, Heading, useColorMode } from '@chakra-ui/react'
import CustomImage from '../../uielements/Image'
import Bg2 from '../../images/dots.png'
import CurvyMore from '../../uielements/CurvyMore'
import FullViewportVideo from '../FullViewportVideo'
import ScrollDownIndicator from '../../uielements/ScrollDownIndicator'

const normalizeAndUppercase = (str) => {
    return str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toUpperCase();
};

const PageHeader = ({ featImg, featVideoId, title, subtitle, curvyText }) => {
    const { colorMode } = useColorMode()

    const gradient =
        colorMode === 'light'
            ? 'radial-gradient( circle farthest-corner at 10% 20%, rgba(0,0,0,0.38) 0.1%, rgba(0,0,0,0.59) 49.8% )'
            : 'radial-gradient( circle farthest-corner at 10% 20%, rgba(0,0,0,0.68) 0.1%, rgba(29,36,49,0.9) 49.8% )'

    switch (true) {
        case !!featVideoId:
            return (
                <Box className={'pageHeader'} position={'relative'} css={{overflow: 'hidden'}} top={0} left={0} right={0}>
                    { featVideoId &&
                        <Box position={'relative'}>
                            <FullViewportVideo videoId={featVideoId} />
                            <Box position={'absolute'} bottom={[4, 4, 8, 24]} left={[6, 6, 8, 16, 36]} zIndex={2}>
                                <Heading mt={4} size={['xl', 'xl', 'xl', '2xl', '3xl', '3xl']} color={'#fff'}>
                                    {normalizeAndUppercase(title)}
                                </Heading>
                            </Box>
                            <ScrollDownIndicator />
                        </Box>
                    }
                </Box>
            )
        case !!featImg:
            return (
                <Box className={'pageHeader'} position={'relative'} css={{overflow: 'hidden'}} top={0} left={0} right={0}>
                    <Box
                        h={['480px', '480px', '600px', '650px', '700px', '800px']}
                        position={'relative'}
                        _before={{
                            content: `""`,
                            display: 'block',
                            background: `${gradient}`,
                            height: '100%',
                            width: '100%',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            zIndex: 2,
                        }}
                    >
                        {featImg && <CustomImage obj={featImg} fit={'cover'} />}
                    </Box>
                    <Box pos="relative" maxW={['80vw', '60vw', '50vw', '40vw']}>
                        <Box position={'absolute'} bottom={[4, 4, 8, 24]} left={[6, 6, 8, 16, 36]} zIndex={2}>
                            {subtitle && <Badge padding={2}>{subtitle}</Badge>}
                            <Heading mt={4} size={['xl', 'xl', 'xl', '2xl', '3xl', '3xl']} color={'#fff'}>
                                {normalizeAndUppercase(title)}
                            </Heading>
                        </Box>
                    </Box>
                    <Box position={'relative'}>
                        <CurvyMore position={'left'} title={curvyText} />
                    </Box>
                </Box>
           )
        default:
            return (
                <Box className={'pageHeader'} position={'relative'} css={{overflow: 'hidden'}} top={0} left={0} right={0}>
                    <Box
                        h={['480px']}
                        position={'relative'}
                        background={'gray.700'}
                        _before={{
                            content: `""`,
                            display: 'block',
                            background: `${gradient}`,
                            height: '100%',
                            width: '100%',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            zIndex: 2,
                        }}
                    >
                            <Box
                                bgImage={Bg2}
                                backgroundSize={'contain'}
                                pos={'absolute'}
                                left={0}
                                right={0}
                                top={0}
                                bottom={0}
                            ></Box>
                    </Box>
                    <Box pos="relative" maxW={['80vw', '60vw', '50vw', '40vw']}>
                        <Box position={'absolute'} bottom={[4, 4, 8, 24]} left={[6, 6, 8, 16, 36]} zIndex={2}>
                            {subtitle && <Badge padding={2}>{subtitle}</Badge>}
                            <Heading mt={4} size={['xl', 'xl', 'xl', '2xl', '3xl', '3xl']} color={'#fff'}>
                                {normalizeAndUppercase(title)}
                            </Heading>
                        </Box>
                    </Box>
                    <Box position={'relative'}>
                        <CurvyMore position={'left'} title={curvyText} />
                    </Box>
                </Box>
            )
    }
}

export default PageHeader
